import { LoadingIndicator } from '@laerdal/life-react-components';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  padding: 50px;
`;

const LoginCallbackPage = () => {
  console.log('LoginCallbackPage: rendered');

  const [search] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const completeLogin = async () => {
      console.log('LoginCallbackPage: starting login callback handling');
      const auth = (window as any).laerdal?.auth;

      if (!auth) {
        console.error('LoginCallbackPage: laerdal.auth is not available on window');
        navigate('/login', { replace: true });
        return;
      }

      // Only call handleRedirectCallback when Auth0 callback params are present
      const hasAuthParams = search.has('code') && search.has('state');
      console.log('LoginCallbackPage: hasAuthParams =', hasAuthParams);

      if (hasAuthParams) {
        try {
          await auth.handleRedirectCallback();
          console.log('LoginCallbackPage: handleRedirectCallback completed successfully');
        } catch (err) {
          console.error('LoginCallbackPage: Auth0 callback error:', err);
          navigate('/login', { replace: true });
          return;
        }
      } else {
        console.warn('LoginCallbackPage: no code/state params in URL, skipping handleRedirectCallback');
      }

      // Verify session after callback
      try {
        const hasSession = await auth.verifySession();
        console.log('LoginCallbackPage: verifySession =', hasSession);

        if (!hasSession) {
          console.warn('LoginCallbackPage: no valid session after callback, redirecting to /login');
          navigate('/login', { replace: true });
          return;
        }
      } catch (err) {
        console.error('LoginCallbackPage: verifySession error:', err);
        navigate('/login', { replace: true });
        return;
      }

      // Navigate to returnUrl or home
      const returnUrl = search.get('returnUrl');
      console.log('LoginCallbackPage: returnUrl =', returnUrl);
      if (returnUrl) {
        // If returnUrl is a full URL on our origin, extract the path
        try {
          const url = new URL(returnUrl);
          if (url.origin === window.location.origin) {
            const path = url.pathname + url.search + url.hash;
            console.log('LoginCallbackPage: navigating to extracted path:', path);
            navigate(path, { replace: true });
            return;
          } else {
            console.warn('LoginCallbackPage: returnUrl origin mismatch:', url.origin, '!==', window.location.origin);
          }
        } catch (err) {
          console.warn('LoginCallbackPage: returnUrl is not a valid URL, treating as path:', err);
        }
        console.log('LoginCallbackPage: navigating to returnUrl as path:', returnUrl);
        navigate(returnUrl, { replace: true });
      } else {
        console.log('LoginCallbackPage: no returnUrl, navigating to /');
        navigate('/', { replace: true });
      }
    };

    completeLogin();
  }, []);

  return <LoadingContainer><LoadingIndicator /></LoadingContainer>;
};

export default LoginCallbackPage;
